var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"copy_box"},[_vm._v(" "+_vm._s(_vm.$t('message.footer.copy'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }